import type { ReactNode } from 'react';

export function Tooltip({ label, children, position = 'top' }: { label: string; children: ReactNode; position?: 'top' | 'bottom' | 'right' }) {
  const positionClasses =
    position === 'bottom'
      ? 'top-full left-1/2 -translate-x-1/2 mt-1.5'
      : position === 'right'
        ? 'left-full top-1/2 -translate-y-1/2 ml-2'
        : 'bottom-full left-1/2 -translate-x-1/2 mb-1.5';

  return (
    <div className="group/tip relative">
      {children}
      <div className={`pointer-events-none absolute z-50 opacity-0 transition-opacity duration-150 group-hover/tip:opacity-100 ${positionClasses}`}>
        <div className="whitespace-nowrap rounded bg-gray-900 px-2 py-1 text-xs font-medium text-white shadow-lg dark:bg-gray-700">
          {label}
        </div>
      </div>
    </div>
  );
}
